import axios from 'lib/axios'

export type ICertificationCodeResponse = {
  status?: string
  message?: string
  data?: {
    subscription_company_id?: number
    client_code?: string
    company_id?: number
    company_name?: string
    inventory_name?: string
    subscription_name?: string
    credits_available?: number
    state?: boolean
    client_code_active?: boolean
  }
}

const validateCertificationCode = async (
  clientCode: string,
): Promise<ICertificationCodeResponse> => {
  try {
    const response = await axios.get(
      `/certification-registration/code/${encodeURIComponent(clientCode.trim())}`,
    )
    return response.data
  } catch (error: any) {
    return {
      status: 'error',
      message:
        error?.response?.data?.message || 'Error al validar el código',
      data: undefined,
    }
  }
}

export default validateCertificationCode
